export interface NavItem {
  path: string;
  translationKey: string;
  external?: boolean;
  externalUrl?: string;
  /** 锚点（如 "#contact"），用于跳转到首页对应板块 */
  hash?: string;
  /** 标记为强调态 CTA（在 Header 中渲染为按钮样式） */
  isCta?: boolean;
  children?: NavItem[];
}

export const navItems: NavItem[] = [
  { path: "/", translationKey: "nav.home" },
  { path: "/serve", translationKey: "nav.serve" },
  { path: "/about", translationKey: "nav.about" },
  // { path: "/schemeCustomization", translationKey: "nav.scheme" },
  {
    path: "/solutions",
    translationKey: "nav.solution",
    children: [
      {
        path: "/furniture-industry-solutions",
        translationKey: "nav.solutions.furniture._label",
      },
      {
        path: "/solutions/robot",
        translationKey: "nav.solutions.robot._label",
        children: [
          {
            path: "/solutions/robot/pool-cleaner",
            translationKey: "nav.solutions.robot.poolCleaner",
          },
          {
            path: "/solutions/robot/vacuum",
            translationKey: "nav.solutions.robot.vacuum",
          },
          {
            path: "/solutions/robot/mower",
            translationKey: "nav.solutions.robot.mower",
          },
          {
            path: "/solutions/robot/embodied",
            translationKey: "nav.solutions.robot.embodied",
          },
          {
            path: "/solutions/robot/commercial",
            translationKey: "nav.solutions.robot.commercial",
          },
        ],
      },
      {
        path: "/solutions/ai-hardware",
        translationKey: "nav.solutions.aiHardware._label",
        children: [
          {
            path: "/solutions/ai-hardware/recorder",
            translationKey: "nav.solutions.aiHardware.recorder",
          },
          {
            path: "/solutions/ai-hardware/ai-glasses",
            translationKey: "nav.solutions.aiHardware.aiGlasses",
          },
          {
            path: "/solutions/ai-hardware/wearable",
            translationKey: "nav.solutions.aiHardware.wearable",
          },
        ],
      },
      {
        path: "/solutions/diy-tools",
        translationKey: "nav.solutions.diyTools._label",
        children: [
          {
            path: "/solutions/diy-tools/3d-printer",
            translationKey: "nav.solutions.diyTools.printer3d",
          },
          {
            path: "/solutions/diy-tools/laser",
            translationKey: "nav.solutions.diyTools.laser",
          },
          {
            path: "/solutions/diy-tools/cnc",
            translationKey: "nav.solutions.diyTools.cnc",
          },
        ],
      },
      {
        path: "/solutions/mobility",
        translationKey: "nav.solutions.mobility._label",
        children: [
          { path: '/e-bike-industry-solutions', translationKey: 'nav.solutions.mobility.ebike' },
          {
            path: "/solutions/mobility/scooter",
            translationKey: "nav.solutions.mobility.scooter",
          },
          {
            path: "/solutions/mobility/elderly",
            translationKey: "nav.solutions.mobility.elderly",
          },
        ],
      },
      {
        path: "/solutions/security",
        translationKey: "nav.solutions.security._label",
        children: [
          {
            path: "/solutions/security/ipc",
            translationKey: "nav.solutions.security.ipc",
          },
          {
            path: "/solutions/security/bird-feeder",
            translationKey: "nav.solutions.security.birdFeeder",
          },
          {
            path: "/solutions/security/hunting-camera",
            translationKey: "nav.solutions.security.huntingCamera",
          },
        ],
      },
      {
        path: "/solutions/new-energy",
        translationKey: "nav.solutions.newEnergy._label",
        children: [
          {
            path: "/solutions/new-energy/solar-storage",
            translationKey: "nav.solutions.newEnergy.solar",
          },
          {
            path: "/solutions/new-energy/home-storage",
            translationKey: "nav.solutions.newEnergy.storage",
          },
          {
            path: "/solutions/new-energy/portable",
            translationKey: "nav.solutions.newEnergy.portable",
          },
          {
            path: "/solutions/new-energy/charging-pile",
            translationKey: "nav.solutions.newEnergy.charging",
          },
          {
            path: "/solutions/new-energy/pool-cleaner",
            translationKey: "nav.solutions.newEnergy.pool",
          },
        ],
      },
      {
        path: "/solutions/appliances",
        translationKey: "nav.solutions.appliances._label",
        children: [
          {
            path: "/solutions/appliances/water-purifier",
            translationKey: "nav.solutions.appliances.waterPurifier",
          },
          {
            path: "/solutions/appliances/ice-maker",
            translationKey: "nav.solutions.appliances.iceMaker",
          },
        ],
      },
      {
        path: "/solutions/fitness/speediance",
        translationKey: "nav.solutions.fitness._label",
      },
      {
        path: "/solutions/pet/smart-life",
        translationKey: "nav.solutions.pet.smartLife",
      },

      {
        path: "/solutions/display",
        translationKey: "nav.solutions.display._label",
        children: [
          {
            path: "/solutions/display/outdoor",
            translationKey: "nav.solutions.display.outdoor",
          },
          {
            path: "/solutions/display/portable-screen",
            translationKey: "nav.solutions.display.portableScreen",
          },
        ],
      },
    ],
  },
  // "出海品牌服务商推荐"（原"合作伙伴 / Tool"）
  { path: "/tool", translationKey: "nav.tool" },
  // 立即咨询：强调按钮态，跳转首页 #contact 锚点
  { path: "/schemeCustomization", translationKey: "nav.consult", isCta: true },
];
